import { createAsyncThunk } from "@reduxjs/toolkit";
import { endpoints } from "../../../api/endpoints";
import {
  IGetReportsFilter,
  IGetReportsParams,
} from "../../../api/types/reports/IGetReportsParams";
import { IReportInfo } from "../../../api/types/reports/IReportInfo";
import { ReportAction } from "../../../api/types/reports/ReportAction";
import { RootState } from "../../rootState";
import { ReportStatus } from "../../reports/types/reportStatus";

interface Params {
  filter?: IGetReportsFilter;
}

export const getTicketGridList = createAsyncThunk<
  IReportInfo[],
  Params | undefined,
  { state: RootState }
>("ticketGrids/getList", async (param, thunkAPI) => {
  const state = thunkAPI.getState();
  if (state.user.isLoggedIn === false)
    throw new Error("Время сессии авторизации истекло");
  if (state.user.info === null) return [];
  const currentFilter: IGetReportsFilter = param?.filter ?? {
    operator: state.ticketGrids.filters.operators,
    status: ReportStatus.template,
  };
  const params: IGetReportsParams = {
    action: ReportAction.getReports,
    ...currentFilter,
    grids: true,
  };
  const response = await endpoints.report.list(params, thunkAPI.signal);
  if (response.error) throw response.error;
  if (response.reports) return response.reports;
  throw new Error("Invalid response from the server.");
});
